import { render, staticRenderFns } from "./AdminEditPastor.vue?vue&type=template&id=d3f78872&scoped=true&"
import script from "./AdminEditPastor.vue?vue&type=script&lang=js&"
export * from "./AdminEditPastor.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditPastor.vue?vue&type=style&index=0&id=d3f78872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f78872",
  null
  
)

export default component.exports